export { default } from './RedFlagTable';
